import React, { useState } from 'react';
import {
	Button, ButtonAppearance, ButtonColor, ButtonSize, WarningExclamation, useSupergridMutations,
} from '@aleph/shared-components';
import { RedditCreateData } from 'wb-reddit/app/routes/superGrid/mutator/utils';
import { RedditLevel } from 'wb-reddit/app/routes/superGrid/utils';
import { useTranslation } from 'react-i18next';

const GeneralError = ({ error }: { error: Error }) => {
	const { t } = useTranslation();
	const [showStacktrace, setShowStacktrace] = useState(false);
	const { clearMutations } = useSupergridMutations<RedditLevel, RedditCreateData>();

	const redirectAndClearStore = () => {
		clearMutations();
		window.location.href = '/';
	};

	return (
		<div className="flex flex-col gap-[24px] p-[40px] items-center justify-center flex-1">
			<WarningExclamation
				width={128}
				height={128}
				fill="hsl(var(--blue-500))"
			/>

			<div className="text-center">
				{
					showStacktrace ? <>
						<div className="font-medium text-[24px] text-black">
							{error?.message}
						</div>
						<div className="text-gray-700">{error?.stack}</div>
					</> : <>
						<div className="font-medium text-[24px] text-black">
							{t('re: general_err.title', 'Oh no! Something went wrong.')}
						</div>

						<div className="text-gray-700">
							{t('re: general_err.body', 'An unknown error has occurred on our end. We\'ve been notified\nand will resolve it as soon as possible.')}
						</div>
					</>
				}
			</div>

			<div className="flex gap-[8px]">
				<Button
					// TODO translate
					title={showStacktrace ? 'Hide stacktrace' : 'Show stacktrace'}
					color={ButtonColor.GRAY}
					size={ButtonSize.LARGE}
					appearance={ButtonAppearance.OUTLINED}
					onClick={() => setShowStacktrace(curr => !curr)}
				/>

				<Button
					title={t('re: general_err.home', 'Take me home')}
					size={ButtonSize.LARGE}
					onClick={redirectAndClearStore}
				/>
			</div>
		</div>
	);
};

export default GeneralError;
